var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { makeActions } from './make-actions';
import { makeFakeActions } from './make-fake-actions';
import { makeSelectors } from './make-selectors';
import { makeState } from './make-state';
export function makeHook(name, options) {
    if (options === void 0) { options = {}; }
    var _a = options.type, type = _a === void 0 ? "gql" : _a, prefix = options.prefix, defaultState = options.defaultState, _b = options.res, res = _b === void 0 ? {} : _b;
    var storageName = prefix ? "".concat(prefix, "-").concat(name) : name;
    var defaultData = defaultState || {};
    if (!(defaultData === null || defaultData === void 0 ? void 0 : defaultData.paging)) {
        defaultData.paging = { page: 0, size: 25 };
    }
    if (!(defaultData === null || defaultData === void 0 ? void 0 : defaultData.sorting)) {
        defaultData.sorting = [{ order: "updatedAt", by: "desc" }];
    }
    if (!(defaultData === null || defaultData === void 0 ? void 0 : defaultData.category)) {
        defaultData.category = "active";
    }
    var actions = makeActions(storageName, name, res);
    if (type === "fake") {
        actions = makeFakeActions(storageName);
    }
    return __assign({ storage: storageName, actions: actions, selectors: makeSelectors(storageName) }, makeState(name, storageName, defaultData));
}
